<template>
  <div class="BankRow" :class="{ active: active }">
    <div class="left">
      <div class="dot">{{ index }}</div>
      <div class="streak" v-if="streak"></div>
    </div>
    <div class="right">
      <h1 class="font-size-middle" @click="$emit('click')">{{ title }}</h1>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BankRow',
  components: {},
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '',
    },
    streak: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    tabClicked(index) {
      this.$emit('tabselected', index);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";

.BankRow {
  position: relative;
  display: flex;
  margin: 2em 0;

  .left {
    user-select: none;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 0 1em;

    .dot {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 2em;
      height: 2em;
      background-color: $dark-text;
      color: black;
      border-radius: 50%;
      transition: 0.1s ease-out background-color;
    }

    .streak {
      flex: 1 1;
      margin-top: 2em;
      min-height: 5em;
      border-left: 1px solid $dark-text;
    }
  }

  .right {
    h1 {
      cursor: pointer;
      margin: 0;
      margin-top: 0.3em;
      color: $dark-text;
      transition: 0.1s ease-out color;

      &:hover {
        color: lighten($dark-text, 10);
      }
    }

    h2 {
      font-weight: normal;
      margin: 0.5em 0;
      color: $dark-text;
      transition: 0.1s ease-out color;

      &.clickable {
        cursor: pointer;

        &:hover {
          color: #eee;
        }
      }
    }

    span {
      color: darken($dark-text, 20);
    }
  }

  &.active {
    .left {
      .dot {
        background-color: $primary;
      }
    }

    .right {
      h1 {
        margin: 0;
        margin-top: 0.3em;
        color: #eee;
      }

      h2 {
        font-weight: normal;
        margin: 0.5em 0;
        color: #bbb;
      }

      span {
        color: $dark-text;
      }
    }
  }
}
</style>
